/* Quais drivers aparecem dentro de uma etapa da jornada.

   O pipeline só liga um driver a uma etapa quando 2 ou mais clientes o citaram
   ali (ADR-001 do data_process). Aqui a tela escolhe, entre esses, os de maior
   volume de cada lado: até 3 que mais ajudam (net > 0) e até 3 que mais
   atrapalham (net < 0).

   Substitui o corte fixo "mais de 15 menções na etapa", que escondia tudo em
   clientes de volume pequeno (Limeira e Rio Branco não tinham nenhum driver
   acima de 15 em Ago–Out/26, apesar de 18 vínculos e até 38 verbatins). Um
   corte por posição escala com o cliente; um número fixo, não. */

export const DRIVERS_POR_LADO = 3;

export function netSentiment(dr) {
  return Math.round(
    (((dr.pos || 0) - (dr.neg || 0)) / Math.max(1, dr.n || 0)) * 100,
  );
}

// Maior volume primeiro; no empate, o sentimento mais forte; depois o nome,
// para a ordem não depender da ordem em que a API devolveu as linhas.
function porVolume(a, b) {
  return (
    (b.n || 0) - (a.n || 0) ||
    Math.abs(netSentiment(b)) - Math.abs(netSentiment(a)) ||
    String(a.d).localeCompare(String(b.d))
  );
}

export function driversEmDestaque(drivers, limite = DRIVERS_POR_LADO) {
  const lista = Array.isArray(drivers) ? drivers : [];
  return {
    positivos: lista
      .filter((d) => netSentiment(d) > 0)
      .sort(porVolume)
      .slice(0, limite),
    negativos: lista
      .filter((d) => netSentiment(d) < 0)
      .sort(porVolume)
      .slice(0, limite),
  };
}
